import Header from "../Header";
import Footer from "../Footer";
import BannerImg from "../assets/Images/banner-1920x450.png";
import BreadcrumbImg from "../assets/Images/nav-bar-bg.jpg";
import BottomLogoImg from "../assets/Images/bottom-logo.png";
import "./ArbitrationQAPage.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UncontrolledCollapse, Button, CardBody, Card } from "reactstrap";
import Breadcrumbs from "../Breadcrumbs";

const ArbitrationQAPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">{t("arbitration_qa_page_header")}</h1>
          <p className="banner-subtitle">{t("arbitration_qa_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_arbitration_qa_page_link1")}</Link>
        <span>{t("breadcrumbs_arbitration_qa_page_span")}</span>
        <Link>{t("breadcrumbs_arbitration_qa_page_link2")}</Link>
      </Breadcrumbs>
      <main className="qa-main-container">
        <header className="qa-header-section">
          <h2 className="qa-section-title">{t("arbitration_qa_page_h3")}</h2>
        </header>
        <section className="qa-content-section">
        <div className="item">
          <Button
            id="toggler"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              marginTop: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("arbitration_qa_page_question1")}
          </Button>
          <UncontrolledCollapse toggler="#toggler">
            <Card className="qa-answer-card">
              <CardBody className="qa-answer-body">
                <p className="mb-3">{t("arbitration_qa_page_question1_text1")}</p>
                <p className="mb-3">{t("arbitration_qa_page_question1_text2")}</p>
                <p className="mb-3">{t("arbitration_qa_page_question1_text3")}</p>
                <p className="mb-3">{t("arbitration_qa_page_question1_text4")}</p>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler1"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              marginTop: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("arbitration_qa_page_question2")}
          </Button>
          <UncontrolledCollapse toggler="#toggler1">
            <Card className="qa-answer-card">
              <CardBody className="qa-answer-body">
                <p className="mb-3">{t("arbitration_qa_page_question2_text1")}<Link to="/arbitrationclauses">{t("arbitration_qa_page_question2_text1a")}</Link></p>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler2"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              marginTop: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("arbitration_qa_page_question3")}
          </Button>
          <UncontrolledCollapse toggler="#toggler2">
            <Card className="qa-answer-card">
              <CardBody className="qa-answer-body">
                <p className="mb-3">{t("arbitration_qa_page_question3_text1")}</p>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler3"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              marginTop: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("arbitration_qa_page_question4")}
          </Button>
          <UncontrolledCollapse toggler="#toggler3">
            <Card className="qa-answer-card">
              <CardBody className="qa-answer-body">
                <p  className="mb-3">{t("arbitration_qa_page_question4_text1")}</p>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler4"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              marginTop: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("arbitration_qa_page_question5")}
          </Button>
          <UncontrolledCollapse toggler="#toggler4">
            <Card className="qa-answer-card">
              <CardBody className="qa-answer-body">
                <p  className="mb-3">{t("arbitration_qa_page_question5_text1")}</p>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler5"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              marginTop: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("arbitration_qa_page_question6")}
          </Button>
          <UncontrolledCollapse toggler="#toggler5">
            <Card className="qa-answer-card">
              <CardBody className="qa-answer-body">
                <p  className="mb-3">{t("arbitration_qa_page_question6_text1")}</p>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler6"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              marginTop: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("arbitration_qa_page_question7")}
          </Button>
          <UncontrolledCollapse toggler="#toggler6">
            <Card className="qa-answer-card">
              <CardBody className="qa-answer-body">
                <p  className="mb-3">{t("arbitration_qa_page_question7_text1")}</p>
                <p  className="mb-3">{t("arbitration_qa_page_question7_text2")}</p>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler7"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              marginTop: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("arbitration_qa_page_question8")}
          </Button>
          <UncontrolledCollapse toggler="#toggler7">
            <Card className="qa-answer-card">
              <CardBody className="qa-answer-body">
                <p  className="mb-3">{t("arbitration_qa_page_question8_text1")}</p>
                <p  className="mb-3">{t("arbitration_qa_page_question8_text2")}</p>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler8"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              marginTop: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("arbitration_qa_page_question9")}
          </Button>
          <UncontrolledCollapse toggler="#toggler8">
            <Card className="qa-answer-card">
              <CardBody className="qa-answer-body">
                <p  className="mb-3">{t("arbitration_qa_page_question9_text1")}</p>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler9"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              marginTop: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("arbitration_qa_page_question10")}
          </Button>
          <UncontrolledCollapse toggler="#toggler9">
            <Card className="qa-answer-card">
              <CardBody className="qa-answer-body">
                <p  className="mb-3">{t("arbitration_qa_page_question10_text1")}</p>
                <p  className="mb-3">{t("arbitration_qa_page_question10_text2")}</p>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler10"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              marginTop: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("arbitration_qa_page_question11")}
          </Button>
          <UncontrolledCollapse toggler="#toggler10">
            <Card className="qa-answer-card">
              <CardBody className="qa-answer-body">
                <p  className="mb-3">{t("arbitration_qa_page_question11_text1")}</p>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler11"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              marginTop: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("arbitration_qa_page_question12")}
          </Button>
          <UncontrolledCollapse toggler="#toggler11">
            <Card className="qa-answer-card">
              <CardBody className="qa-answer-body">
                <p  className="mb-3">{t("arbitration_qa_page_question12_text1")}</p>
                <p  className="mb-3">{t("arbitration_qa_page_question12_text2")}</p>
                <p  className="mb-3">{t("arbitration_qa_page_question12_text3")}</p>
                <p  className="mb-3">{t("arbitration_qa_page_question12_text4")}</p>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler12"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              marginTop: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("arbitration_qa_page_question13")}
          </Button>
          <UncontrolledCollapse toggler="#toggler12">
            <Card className="qa-answer-card">
              <CardBody className="qa-answer-body">
                <p  className="mb-3">{t("arbitration_qa_page_question13_text1")}</p>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler13"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              marginTop: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("arbitration_qa_page_question14")}
          </Button>
          <UncontrolledCollapse toggler="#toggler13">
            <Card className="qa-answer-card">
              <CardBody className="qa-answer-body">
                <p  className="mb-3">{t("arbitration_qa_page_question14_text1")}</p>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler14"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              marginTop: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("arbitration_qa_page_question15")}
          </Button>
          <UncontrolledCollapse toggler="#toggler14">
            <Card className="qa-answer-card">
              <CardBody className="qa-answer-body">
                <p  className="mb-3">{t("arbitration_qa_page_question15_text1")}</p>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler15"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              marginTop: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("arbitration_qa_page_question16")}
          </Button>
          <UncontrolledCollapse toggler="#toggler15">
            <Card className="qa-answer-card">
              <CardBody className="qa-answer-body">
                <p  className="mb-3">{t("arbitration_qa_page_question16_text1")}</p>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler16"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              marginTop: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("arbitration_qa_page_question17")}
          </Button>
          <UncontrolledCollapse toggler="#toggler16">
            <Card className="qa-answer-card">
              <CardBody className="qa-answer-body">
                <p  className="mb-3">{t("arbitration_qa_page_question17_text1")}</p>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        </section>
      </main>
      <div className="temporary">
        <img src={BottomLogoImg} alt="" />
      </div>

      <Footer />
    </>
  );
};

export default ArbitrationQAPage;
